import { gridViewExpand } from './grid-view.js';
import { debounce } from '@cloudsuite/theme_library/scripts/helper/';

window.addEventListener('pageshow', (event) => {
    if (event.persisted) {
        $('#js-loader-modal').modal('hide');
    } else {
        $(document).on('click', '[data-js-filter-url]', function(e) {
            e.stopImmediatePropagation();
            e.stopPropagation();
            e.preventDefault();
            
            $('#js-loader-modal').modal({ backdrop: 'static', keyboard: false });
        
            let url_string= window.location.href;
            const btnURL = this.getAttribute('href');
        
            const url = new URL(url_string);
            const minKey = url.searchParams.has("min");
            const maxKey = url.searchParams.has("max");
            const minValue = url.searchParams.get("min");
            const maxValue = url.searchParams.get("max");
            const newParam = `min=${minValue}&max=${maxValue}`
        
          
            if (minKey && maxKey ) {
                window.location.href = `${btnURL}&${newParam}`
        
            } else {
                window.location.href = btnURL;
            }
        });
    }
});

// DISPLAY ALT IMAGE ON PRODUCT HOVER
$('.product').find('.image').hoverIntent(
    function () {
        $(this).find('.alt-image').show();
    },
    function () {
        $(this).find('.alt-image').hide();
    }
);

const stickyContainer = document.querySelector('.sticky-plp');
const filter = document.querySelector('.mobile-filtering-btn');
const search = document.querySelector('.search-options__tools');
const menuBackdrop = document.querySelector('.menuBackdrop');
const clFilter = filter?.cloneNode(true);
const clSearch = search?.cloneNode(true);
let currentPosition;
let lastScrollTop = 0;
let headerHeightA = '155px';
let headerHeightB = '120px';

function stickyFilteringMobile() {
    const contents = document.querySelectorAll('.search-options__tools');

    if (contents.length > 0 && window.innerWidth < 768) {
        const observer = new IntersectionObserver(entries => {
            entries.forEach((entry) => {
                const isIntersecting = entry.isIntersecting;
                if ( isIntersecting ) {
                    window.removeEventListener("scroll", checkScrollDirection);
                    removeClone();
                } else {
                    window.addEventListener("scroll", checkScrollDirection);
                }
            });
        }, {
            threshold: [0.5, 1]
        });
        contents.forEach((content) => observer.observe(content));
    }
}

function setHeightToTablets() {
    if (!menuBackdrop.classList.contains('_show') && $(window).scrollTop() < 35) {
        stickyContainer.style.top = headerHeightA;
    } else {
        if(window.innerWidth < 768) {
            const headertop = document.querySelector('.header-top-nav').offsetHeight;
			const headerMobile = document.querySelector('.header-mobile').offsetHeight;
            stickyContainer.style.top = headerMobile + headertop +'px';
        } else {
            stickyContainer.style.top = headerHeightB;
        }
    }
}

function resetScrollPosition() {
    const grids = document.querySelectorAll('[data-js-grid-view]');
    grids.forEach(item => {
        item.addEventListener('click', (e) => {
            currentPosition = window.pageYOffset || document.documentElement.scrollTop;
            lastScrollTop = currentPosition;
        });
    });
}

function removeClone() {
    stickyContainer.classList.remove('active');
    while (stickyContainer.firstChild) {
        stickyContainer.removeChild(stickyContainer.firstChild);
    }
}

function displayClone() {
    if (!stickyContainer.classList.contains('active')) {
        stickyContainer.appendChild(clFilter)
        stickyContainer.appendChild(clSearch)
        stickyContainer.classList.add('active');
        gridViewExpand();
        setHeightToTablets();
        resetScrollPosition();
    }
}; 

function checkScrollDirection() {
    currentPosition = window.pageYOffset || document.documentElement.scrollTop;
    if (currentPosition > lastScrollTop) {
        // downscroll
        removeClone();
    } else if (currentPosition < lastScrollTop) {
        // upscroll
        displayClone();
    } 
    lastScrollTop = currentPosition <= 0 ? 0 : currentPosition;
};

stickyFilteringMobile();
window.addEventListener('resize', debounce(200, () => {
    stickyFilteringMobile();
}));